const METRIC_LINKS = {
  verified_deals: '/deals',
  trusted_stores: '/outlets',
  avg_savings: '/deals',
};

const DEFAULT_ITEMS = [
  { metricKey: 'verified_deals', label: 'Verified Deals', displayOrder: 0 },
  { metricKey: 'trusted_stores', label: 'Trusted Stores', displayOrder: 1 },
  { metricKey: 'avg_savings', label: 'Avg. User Savings', displayOrder: 2 },
  { label: 'System Updates', value: 'Daily', displayOrder: 3 },
];

function formatCountPlus(count) {
  const n = Math.max(0, Number(count) || 0);
  return `${n.toLocaleString('en-KE')}+`;
}

function formatKesAmount(amount) {
  const n = Math.max(0, Math.round(Number(amount) || 0));
  return `KES ${n.toLocaleString('en-KE')}`;
}

function formatMetricValue(metricKey, computed) {
  if (!computed || !metricKey) return '';
  if (metricKey === 'verified_deals') return formatCountPlus(computed.verified_deals);
  if (metricKey === 'trusted_stores') return formatCountPlus(computed.trusted_stores);
  if (metricKey === 'avg_savings') {
    return Number(computed.avg_savings) > 0
      ? formatKesAmount(computed.avg_savings)
      : 'KES 0';
  }
  return '';
}

/** Reconcile trusted store count with live /outlets list (same filter as Stores & Merchants page). */
export function applyLiveOutletCountToStats(stats, outletCount) {
  const count = Math.max(0, Number(outletCount) || 0);
  if (!stats?.items?.length || count <= 0) return stats;

  const items = stats.items.map((item) => {
    if (item.metricKey !== 'trusted_stores') return item;
    return {
      ...item,
      value: formatCountPlus(count),
      linkTo: item.linkTo || METRIC_LINKS.trusted_stores,
    };
  });

  return { ...stats, items };
}

export function countOutletsFromApiResponse(response) {
  if (Array.isArray(response)) return response.length;
  if (Array.isArray(response?.data)) return response.data.length;
  if (Array.isArray(response?.outlets)) return response.outlets.length;
  return 0;
}

function isSystemUpdatesItem(item) {
  return String(item?.label || '').trim().toLowerCase().includes('system update');
}

function buildItemsFromComputed(computed) {
  if (!computed) return [];
  return DEFAULT_ITEMS.map((template) => {
    if (isSystemUpdatesItem(template)) {
      return {
        label: template.label,
        value: template.value || 'Daily',
        linkTo: null,
        isActive: true,
      };
    }
    const metricKey = template.metricKey;
    return {
      metricKey,
      label: template.label,
      value: formatMetricValue(metricKey, computed),
      linkTo: METRIC_LINKS[metricKey] || null,
      isActive: true,
    };
  });
}

/** Normalize API payload for StatsStrip — fills from `computed` when items are missing or blank. */
export function resolveStatsStripForDisplay(data) {
  if (!data || typeof data !== 'object') {
    return { isActive: true, items: [] };
  }

  const computed = data.computed || null;
  let items = (Array.isArray(data.items) ? data.items : []).filter(
    (item) => item && item.isActive !== false
  );

  const itemsMissingValues = items.length > 0 && items.every(
    (item) => !String(item.value || '').trim()
  );

  if (items.length === 0 || itemsMissingValues) {
    const fromComputed = buildItemsFromComputed(computed);
    if (fromComputed.length) {
      items = fromComputed;
    }
  } else {
    items = items.map((item) => {
      const value = String(item.value || '').trim();
      if (value) return item;
      if (item.metricKey && computed) {
        return {
          ...item,
          value: formatMetricValue(item.metricKey, computed),
          linkTo: item.linkTo || METRIC_LINKS[item.metricKey] || null,
        };
      }
      if (isSystemUpdatesItem(item)) {
        return { ...item, value: value || 'Daily' };
      }
      return item;
    });
  }

  return {
    isActive: data.isActive !== false,
    items,
  };
}
